import { AnyAction } from 'redux';
import { RESET_STATE, GET_ALL_JIT_USERS, GET_ALL_JIT_USERS_LOADING, JIT_USERS_COUNT } from '../constants';

const initialState = {
    jitUsers: [],
    jitUsersLoading: false,
    jitUsersCount: 0
};

export function jitUsers(state = initialState, action: AnyAction) {
    const { payload, type } = action;

    switch (type) {
        case RESET_STATE:
            return initialState;
        case GET_ALL_JIT_USERS:
            return {
                ...state,
                jitUsers: payload
            };
        case GET_ALL_JIT_USERS_LOADING:
            return {
                ...state,
                jitUsersLoading: payload
            };
        case JIT_USERS_COUNT:
            return {
                ...state,
                jitUsersCount: payload
            };
        default:
            return state;
    }
}
